module.exports = __webpack_public_path__ + "img/ngs_thumb.0331dbe7.png";